import {Checkbox, CheckboxProps} from "@mui/material";

export default function TableCheckbox(props: CheckboxProps) {
    return (
        <Checkbox
            {...props}
            sx={{
                color: "#1062D0",
            }}
        />
    );
}
